import { render } from "./InvertedBlackButton.vue?vue&type=template&id=acf3a514&scoped=true"
import script from "./InvertedBlackButton.vue?vue&type=script&lang=js"
export * from "./InvertedBlackButton.vue?vue&type=script&lang=js"

import "./InvertedBlackButton.vue?vue&type=style&index=0&id=acf3a514&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acf3a514"]])

export default __exports__